import React, { useEffect, useState } from "react";
import { Row, Col, Container, Modal } from "react-bootstrap";
import { useLocation, useParams } from "react-router-dom";
import SearchBar from "../../components/searchbar/SearchBar";
import "./policy.css";
import parse from "html-react-parser";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  GetPolicyDetails,
  selectPolicyDetails,
} from "../../features/ethicspolicydetails/ethicspolicydetailsSlice";
import Feedback from "../../components/feedbackNote/Feedback";
import ENGModalHeader from "../../components/modal/ENGModalHeader";
import ENGModalBody from "../../components/modal/ENGModalBody";
import ENGModalFooter from "../../components/modal/ENGModalFooter";
import icTitle from "../../assets/images/ic-edit-modal.svg";
import { engPdfUrl, policyPdfAPi } from "../../features/network/ApiCall";
const PolicyDetails = (props: any) => {
  let { id }: any = useParams();

  // const data = useAppSelector(selectPolicyDetails);
  const dispatch = useAppDispatch();
  const location: any = useLocation();
  const userDetails = localStorage.getItem("userDetails");
  const userDetailsList: any = userDetails;
  const policySourceType = JSON.parse(userDetailsList);
  const data = location.state.data;
  useEffect(() => {
    // async function fetchPolicyDetails() {
    //   await dispatch(GetPolicyDetails(id));
    // }
    // fetchPolicyDetails();
    // console.log(location.state.data,"location data");
  }, []);
  const [modalShow2, setModalShow2] = useState(false);
  const handleClose2 = () => setModalShow2(false);
  const handleShow2 = () => setModalShow2(true);
  const guidelines: string = data?.generalGuidLines;
  return (
    <>
      <Container
        style={{ fontFamily: 'Saira' }}
        className='mob-lr-padding0'
        fluid
      >
        <Feedback pageName='Ethics Policies' />
        <Row>
          <Col sm={6} className='mob-lr-padding0'>
            <p style={styles.text1} className='mb-0 mt-4'>
              E&G Policies {'>'} {data?.policyName}
            </p>
            <span style={styles.header}>Ethics policies</span>
          </Col>
          <Col sm={2} className='mob-lr-padding0'></Col>
          {/* <Col sm={4} className="mob-lr-padding0 mob-t-padding0">
            <SearchBar />
          </Col> */}
          <Col sm={6} className='mob-lr-padding0 mob-t-padding16'>
            <h6 className='mb-4 title' style={{ color: '#fff' }}>
              {data?.policyName}
            </h6>
          </Col>
        </Row>

        <div className='b_shadow bgwhite'>
          <Row className=' mob-bgwhite-lrpad0'>
            <Col sm={3} className='heading desk-lr-padding12'>
              Context
            </Col>
            <Col sm={9} className='data desk-lr-padding0'>
              {/* {data?.objective} */}
              {data?.objectives ? data?.objectives : 'Not Available'}
            </Col>
          </Row>

          <Row className=' mob-bgwhite-lrpad0'>
            <Col sm={3} className='heading desk-lr-padding12'>
              Eligibility
            </Col>
            <Col sm={9} className='data desk-lr-padding0'>
              {' '}
              {/* {data?.eligibility} */}
              {data?.eligibility ? data?.eligibility : 'Not Available'}
            </Col>
          </Row>

          <Row className=' mob-bgwhite-lrpad0'>
            <Col sm={3} className='heading desk-lr-padding12'>
              General guidelines
            </Col>
            <Col sm={9} className='data desk-lr-padding0'>
              <div>{guidelines ? parse('' + guidelines) : 'Not Available'}</div>
            </Col>
          </Row>

          {data.downloadLink != '' && (
            <Row className='mob-bgwhite-lrpad0'>
              <Col lg={9} md={9} sm={9} xs={5}>
                {' '}
              </Col>
              <Col lg={3} md={3} sm={3} xs={7}>
                {policySourceType?.mahindraCompanyList?.policySource ===
                true ? (
                  <a
                    className='button'
                    href={`${engPdfUrl}${data.policy_pdf_link}`}
                    target='_blank'
                    rel='noopener noreferrer'
                    //  onClick={handleShow2}
                    style={styles.button}
                  >
                    VIEW PDF
                  </a>
                ) : (
                  <a
                    className='button'
                    href={`${policyPdfAPi}${data.policy_pdf_link}`}
                    target='_blank'
                    rel='noopener noreferrer'
                    //  onClick={handleShow2}
                    style={styles.button}
                  >
                    VIEW PDF
                  </a>
                )}
              </Col>
            </Row>
          )}
        </div>
      </Container>
      <Modal
        show={modalShow2}
        onHide={handleClose2}
        backdrop='static'
        size='lg'
        keyboard={false}
      >
        <ENGModalHeader icon={icTitle} title='View PDF' />
        <ENGModalBody
          contents={
            <>
              {/* <iframe
                src={`${policyPdfAPi}${data.policy_pdf_link}`}
                width='800'
                height='600'
              ></iframe> */}
            </>
          }
        />
        <ENGModalFooter closeMethod={handleClose2} />
      </Modal>
    </>
  );
};

const styles: any = {
  txtBlack: { color: "#000" },
  button: {
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: 600,
    fontStretch: "normal",
    fontStyle: "normal",
    borderRadius: "0",
    backgroundColor: "#e31837",
    letterSpacing: "normal",
    border: "0px",
  },
  header: {
    fontSize: "32px",
    color: "white",
    fontWeight: "500",
  },
  text1: {
    textTransform: "uppercase",
    fontSize: "10px",
    color: "#fff",
    fontWeight: "500",
  },
  text2: {
    fontSize: "16px",
    color: "#242424",
    fontWeight: "normal",
  },
  heading: {
    fontFamily: "Saira",
    fontSize: "12px",
    color: "black",
    fontWeight: "600",
  },
  data: {
    fontFamily: "Saira",
    fontSize: "12px",
    color: "black",
    fontWeight: "450",
  },
};

export default PolicyDetails;
